import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import dividerBackground from '../../../assets/Rectangle65.png';
import TypographyBlock from '../typography_block/typographyblock';
import Divider from '../divider/Divider';
import CardGrid from '../cardGrid/CardGrid';
import BlogCard from '../cards/blogCard/blogCard';
import Button from '../button/button';
import BlogCardSlider from '../blogCardSlider/BlogCardSlider';
import COMMON_CONSTANTS from '../../../constants/commonConstants';

import { useCommonDataContext } from '../../../context/commonDataContext';

export default function AmpFeaturedSection() {
  const { commonData } = useCommonDataContext();
  const [data, setData] = useState({});
  const theme = useTheme();
  const tmpImageUrl = 'https://picsum.photos/360/241';
  const wordpressUrl = COMMON_CONSTANTS.getWordpressBaseUrl();
  const appServerUrl = COMMON_CONSTANTS.appServerUrl;
  useEffect(() => {
    if (commonData?.['ampFeaturedCards']) {
      setData(commonData['ampFeaturedCards']);
    }
  }, [commonData]);

  return (
    <div className='amp-featured-section'>
      <Box
        sx={{
          backgroundColor: '#EBEEF2',
          mt: '100px',
          pt: { xs: '50px', lg: '100px' },
          pb: { xs: '20px', lg: '100px' },
          // Scoped styles for this component only
          '& h3': { 
            color: `${theme?.palette?.primary?.main} !important`,
            fontWeight: "700 !important",
            fontSize: "3rem !important",
            lineHeight: "3.375rem !important",
            letterSpacing: "0% !important",
          },
          '& h5': { 
            color: `${theme?.palette?.primary?.main} !important`,
            fontWeight: "700 !important",
            fontSize: "1.5rem !important",
            lineHeight: "2rem !important",
            letterSpacing: "0% !important",
            fontStyle: "Bold !important",
          },
        }}
      >
        <Box sx={{ maxWidth: '1121px', margin: '0 auto' }}>
          <Box
            sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mx: { xs: '20px', lg: 0 },
              }}
            >

              {data?.divider_type === 'image' ? (
                <Divider
                  backgroundImage={`${wordpressUrl}${data?.divider_image?.url}` || dividerBackground}
                  height="6px !important"
                  width="87px !important"
                />
              ) : (
                <Divider backgroundColor={`${data?.divider_color} !important`} height="6px !important" width="87px !important" />
              )}
              <TypographyBlock
                headerChildren={data?.section_title}
                headerVariant="h3"
              />
            </Box>
          </Box>

          {/* CardGrid Desktop View */}
          <Box
            sx={{
              display: { xs: 'none', lg: 'block' },
              justifyContent: 'center',
              mt: '25px',
            }}
          >
            <CardGrid columnSpacing={0} rowSpacing={0} maxWidth={'360px'}>
              {data?.cards?.map((card, index) => (
                <BlogCard
                  key={index}
                  image={
                    `${wordpressUrl}${card?.acf?.card_image?.url}` || tmpImageUrl
                  }
                  imageAlt={card?.card_image?.alt || `Illustration for ${card?.acf?.card_title}`}
                  title={card?.acf?.card_title || 'Card Title'}
                  content={
                    card?.acf?.card_summary?.length > 0 ? (<div
                      dangerouslySetInnerHTML={{
                        __html:
                          card?.acf?.card_summary,
                      }}
                    />) : (<></>)
                  }
                  action={
                    <div className={`card-button-container ${card?.acf?.button_type || ''}`}>
                      <Button
                        color="secondary"
                        fontFamily="body.fontFamily.secondary"
                        fontWeight={700}
                        size="large"
                        sx={{ mt: 3, px: 3, py: 2, position: 'relative' }}
                        href={`${appServerUrl}/${card?.slug}`}
                      >
                        {card?.acf?.button_label || 'Read More'}
                        <span className="sr-only">
                          {card?.acf?.button_label 
                            ? `${card?.acf?.button_label} - ${card?.acf?.card_title || 'featured content'}`
                            : `Read more about ${card?.acf?.card_title || 'this featured content'}`
                          }
                        </span>
                      </Button>
                    </div>
                  }
                  backgroundColor="transparent"
                  elevation={0}
                />
              ))}
            </CardGrid>
          </Box>
        </Box>

        {/* Card Slider Mobile View */}
        <Box sx={{ display: { xs: 'block', lg: 'none' }, mt: '20px' }}>
          <div className='mobile-cards'>
            <BlogCardSlider
              blogCardList={(
                data?.cards?.map((card, index) => ({
                  image: card?.acf?.card_image?.url || tmpImageUrl,
                  imageAlt: card?.card_image?.alt || `Illustration for ${card?.acf?.card_title}`,
                  title: card?.acf?.card_title || 'Card Title',
                  content: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: card?.acf?.card_summary?.length > 0 ? card?.acf?.card_summary : `<div></div>`,
                      }}
                    />
                  ),
                  href: `${appServerUrl}/${card?.slug}`,
                  buttonLabel: card?.acf?.button_label || 'Read More',
                  cardTitle: card?.acf?.card_title,
                })) || []
              )}
              elevation={0}
              shakeDuration={0.3}
              slideSpeed={0.75}
            />
          </div>
        </Box>

      </Box>
    </div>
  );
}